import Pusher from 'pusher-js';
import Echo from 'laravel-echo';
import { AlertColor } from '@mui/material/Alert';

export type FailedTaxpayer = {
  name: string;
  pid: string;
};

export type MessageType = {
  message: string;
  status: AlertColor;
  failedTaxpayers?: FailedTaxpayer[];
  batchId?: string;
};

Pusher.logToConsole = import.meta.env.MODE === 'development';

type Data = {
  appKey: string;
  cluster: string;
};

export let echo: Echo<any> | null = null;

function getCsrfToken(): string {
  return (
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.content ?? ''
  );
}

export function createConnection(data: Data): Echo<any> {
  if (!echo) {
    // Force native WebSocket transport. The default pusher-js negotiation
    // can fall back to sockjs XHR streaming/polling, which keeps an XHR
    // in flight at all times and (a) shows the tab favicon as perpetually
    // loading, (b) triggers continuous OPTIONS+POST pairs to
    // sockjs-*.pusher.com. With WebSocket the connection is one persistent
    // socket frame with no recurring HTTP.
    echo = new Echo({
      broadcaster: 'pusher',
      key: data.appKey,
      cluster: data.cluster,
      forceTLS: true,
      enabledTransports: ['ws', 'wss'],
      disabledTransports: ['xhr_streaming', 'xhr_polling', 'sockjs'],
      auth: {
        headers: {
          'X-CSRF-TOKEN': getCsrfToken(),
        },
      },
    });
  }
  return echo;
}
